export enum PlanPeriod {
    MENSUAL = 'Mensual',
    ANUAL = 'Anual'
}